import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';

export interface CurrencyRate {
    code: string;
    icon: string;
    from: string;
    to: string;
    bank: string;
    value: string;
}

@Component({
    selector: 'app-lifetime-expense',
    standalone: true,
    imports: [CommonModule, CdkOverlayOrigin, WidgetEdit],
    templateUrl: './lifetime-expense.html',
    styleUrl: './lifetime-expense.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LifetimeExpense {
    @Input() title = 'LIFETIME EXPENSE';
    @Input() size: 'small' | 'medium' | 'half' | 'full' = 'medium';
    @Input() index = 0;
    @Input() isEditMode = false;
    @Input() isAddMode = false;
    @Output() addWidget = new EventEmitter<void>();
    @Input() activeDropdownIndex: number | null = null;
    @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
    @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
    @Input() changeWidgetSize!: (index: number, size: any) => void;
    @Input() removeWidget!: (index: number) => void;

    currentIndex = 0;

    rates: CurrencyRate[] = [
        { code: 'EU', icon: 'assets/icons/img_umbrella.svg', from: '1 EUR =', to: '1.1478 USD', bank: 'Banxx', value: '24.05' },
        { code: 'US', icon: 'assets/icons/img_shopping-basket.svg', from: '1 USD =', to: '1.1478 INR', bank: 'Banxx', value: '24.05' },
        { code: 'GB', icon: 'assets/icons/img_umbrella.svg', from: '1 GBP =', to: '1.3456 USD', bank: 'Banxx', value: '24.05' },
        { code: 'JP', icon: 'assets/icons/img_shopping-basket.svg', from: '1 JPY =', to: '0.0075 USD', bank: 'Banxx', value: '24.05' },
        { code: 'CA', icon: 'assets/icons/img_umbrella.svg', from: '1 CAD =', to: '0.7890 USD', bank: 'Banxx', value: '24.05' },
        { code: 'AU', icon: 'assets/icons/img_shopping-basket.svg', from: '1 AUD =', to: '0.7234 USD', bank: 'Banxx', value: '24.05' },
        { code: 'CH', icon: 'assets/icons/img_umbrella.svg', from: '1 CHF =', to: '1.0890 USD', bank: 'Banxx', value: '24.05' },
        { code: 'CN', icon: 'assets/icons/img_shopping-basket.svg', from: '1 CNY =', to: '0.1567 USD', bank: 'Banxx', value: '24.05' }
    ];

    get visibleItemsCount(): number {
        switch (this.size) {
            case 'small': return 1;
            case 'medium': return 2;
            case 'half': return 3;
            case 'full': return 6;
            default: return 2;
        }
    }

    next() {
        if (this.isAddMode) return;
        if (this.currentIndex + this.visibleItemsCount < this.rates.length) {
            this.currentIndex += this.visibleItemsCount;
        }
    }

    prev() {
        if (this.isAddMode) return;
        if (this.currentIndex - this.visibleItemsCount >= 0) {
            this.currentIndex -= this.visibleItemsCount;
        } else {
            this.currentIndex = 0;
        }
    }

    get paginationText(): string {
        const end = Math.min(this.currentIndex + this.visibleItemsCount, this.rates.length);
        if (this.visibleItemsCount === 1) {
            return `${this.currentIndex + 1} / ${this.rates.length}`;
        }
        return `${this.currentIndex + 1}-${end} / ${this.rates.length}`;
    }

    get canGoNext(): boolean {
        return this.currentIndex + this.visibleItemsCount < this.rates.length;
    }

    get canGoPrev(): boolean {
        return this.currentIndex > 0;
    }
}
